import React from 'react';
import { Link } from 'react-router-dom';

const HeroSection: React.FC = () => {
  return (
    <div className="relative bg-purple-900 overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 z-0 opacity-40" 
        style={{
          backgroundImage: 'url("https://images.pexels.com/photos/261327/pexels-photo-261327.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2")',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      ></div>
      
      {/* Content */}
      <div className="container mx-auto px-4 py-24 md:py-32 relative z-10">
        <div className="max-w-2xl">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 animate-fade-in">
            Crystal Clear Pools, 
            <span className="text-orange-400"> Expert Care</span>
          </h1>
          <p className="text-xl text-white/90 mb-8 animate-fade-in animation-delay-200">
            Central Florida's premier pool cleaning and maintenance service. Professional care that keeps your pool sparkling clean all year round.
          </p>
          <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4 animate-fade-in animation-delay-400">
            <Link 
              to="/quote" 
              className="px-6 py-3 bg-orange-500 text-white font-bold rounded-md hover:bg-orange-600 transition-colors duration-200 text-center"
            >
              Get a Free Quote
            </Link>
            <Link 
              to="/services" 
              className="px-6 py-3 bg-transparent border-2 border-white text-white font-bold rounded-md hover:bg-white/10 transition-colors duration-200 text-center"
            >
              Explore Services
            </Link>
          </div>
          <div className="mt-8 bg-orange-500/90 backdrop-blur-sm p-4 rounded-lg inline-block animate-fade-in animation-delay-600">
            <p className="text-white font-medium">
              <span className="font-bold">Limited Time Offer:</span> First month FREE for new customers!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;